import React from 'react';
import VisaCard from '../assets/svg-icons/cards/VisaCard';
import AmexCard from '../assets/svg-icons/cards/AmexCard';
import MasterCard from '../assets/svg-icons/cards/MasterCard';
import JCBCard from '../assets/svg-icons/cards/JCBCard';
import DiscoverCard from '../assets/svg-icons/cards/DiscoverCard';
import DinerClubCard from '../assets/svg-icons/cards/DinerClubCard';
import HomeIcon from '../assets/svg-icons/homeTabs/HomeIcon';
import HomeFilledIcon from '../assets/svg-icons/homeTabs/HomeFilledIcon';
import ResourcesIcon from '../assets/svg-icons/homeTabs/ResourcesIcon';
import ResourcesFilledIcon from '../assets/svg-icons/homeTabs/ResourcesFilledIcon';
import CoachingIcon from '../assets/svg-icons/homeTabs/CoachingIcon';
import CoachingFilledIcon from '../assets/svg-icons/homeTabs/CoachingFilledIcon';
import StoreIcon from '../assets/svg-icons/homeTabs/StoreIcon';
import StoreFilledIcon from '../assets/svg-icons/homeTabs/StoreFilledIcon';
import BaselineErrorIcon from '../assets/svg-icons/BaselineErrorIcon';
import CheckCircleIcon from '../assets/svg-icons/CheckCircleIcon';
import EmptyReadings from '../assets/svg-icons/EmptyReadings';
import EmptyContacts from '../assets/svg-icons/EmptyContacts';
import EmptyCards from '../assets/svg-icons/EmptyCards';
import EmptyAddresses from '../assets/svg-icons/EmptyAddresses';
import EmptyFeed from '../assets/svg-icons/EmptyFeed';
import Logo from '../assets/svg-icons/Logo';
import LogoGroup from '../assets/svg-icons/LogoGroup';
import CheckboxUncheckedIcon from '../assets/svg-icons/CheckboxUncheckedIcon';
import CheckboxCheckedIcon from '../assets/svg-icons/CheckboxCheckedIcon';
import RadioUncheckedIcon from '../assets/svg-icons/RadioUncheckedIcon';
import RadioCheckedIcon from '../assets/svg-icons/RadioCheckedIcon';
import FilterIcon from '../assets/svg-icons/FilterIcon';
import VerticalDotsIcon from '../assets/svg-icons/VerticalDotsIcon';
import UpArrowIcon from '../assets/svg-icons/UpArrowIcon';
import DownArrowIcon from '../assets/svg-icons/DownArrowIcon';
import LeftArrowIcon from '../assets/svg-icons/LeftArrowIcon';
import RightArrowIcon from '../assets/svg-icons/RightArrowIcon';
import LockIcon from '../assets/svg-icons/LockIcon';
import HeartIcon from '../assets/svg-icons/HeartIcon';
import HeartFilledIcon from '../assets/svg-icons/HeartFilledIcon';
import CloseIcon from '../assets/svg-icons/CloseIcon';
import TickIcon from '../assets/svg-icons/TickIcon';
import PlusIcon from '../assets/svg-icons/PlusIcon';
import MapPinIcon from '../assets/svg-icons/MapPinIcon';
import MapPinFilledIcon from '../assets/svg-icons/MapPinFilledIcon';
import LinkIcon from '../assets/svg-icons/LinkIcon';
import USAFlag from '../assets/svg-icons/USAFlag';
import ClosedEyeIcon from '../assets/svg-icons/ClosedEyeIcon';
import OpenEyeIcon from '../assets/svg-icons/OpenEyeIcon';
import SmileIcon from '../assets/svg-icons/SmileIcon';
import RefreshIcon from '../assets/svg-icons/RefreshIcon';
import CardFilledIcon from '../assets/svg-icons/CardFilledIcon';
import CardIcon from '../assets/svg-icons/CardIcon';
import BluetoothIcon from '../assets/svg-icons/BluetoothIcon';
import EditIcon from '../assets/svg-icons/EditIcon';
import NoNetworkIcon from '../assets/svg-icons/NoNetworkIcon';
import UsersIcon from '../assets/svg-icons/UsersIcon';
import MoneyIcon from '../assets/svg-icons/MoneyIcon';
import LocationQuestionIcon from '../assets/svg-icons/LocationQuestionIcon';
import InfoRectIcon from '../assets/svg-icons/InfoRectIcon';
import HotspotIcon from '../assets/svg-icons/HotspotIcon';
import LogoutIcon from '../assets/svg-icons/LogoutIcon';
import MapLocationIcon from '../assets/svg-icons/MapLocationIcon';
import BloodIcon from '../assets/svg-icons/BloodIcon';
import UserIcon from '../assets/svg-icons/UserIcon';
import RequestFailedIcon from '../assets/svg-icons/RequestFailedIcon';
import UserFilledIcon from '../assets/svg-icons/UserFilledIcon';
import SeparatorIcon from '../assets/svg-icons/SeparatorIcon';
import AddIcon from '../assets/svg-icons/AddIcon';
import MessageIcon from '../assets/svg-icons/MessageIcon';
import EmailIcon from '../assets/svg-icons/EmailIcon';
import PhoneIcon from '../assets/svg-icons/PhoneIcon';
import RecentReadingsIcon from '../assets/svg-icons/RecentReadingsIcon';
import TimeIcon from '../assets/svg-icons/TimeIcon';
import DateIcon from '../assets/svg-icons/DateIcon';
import ClockIcon from '../assets/svg-icons/ClockIcon';
import LongBackArrowIcon from '../assets/svg-icons/LongBackArrowIcon';
import ShareIcon from '../assets/svg-icons/ShareIcon';
import CartIcon from '../assets/svg-icons/CartIcon';
import CalendarIcon from '../assets/svg-icons/CalendarIcon';
import PurchaseSuccessIcon from '../assets/svg-icons/PurchaseSuccessIcon';
import HypoArrowIcon from '../assets/svg-icons/HypoArrowIcon';
import HyperArrowIcon from '../assets/svg-icons/HyperArrowIcon';
import NormalLevelIcon from '../assets/svg-icons/NormalLevelIcon';
import Triangle from '../assets/svg-icons/Triangle';
import MakeAppointmentIcon from '../assets/svg-icons/MakeAppointmentIcon';
import NoAdvisors from '../assets/svg-icons/NoAdvisors';

export const cardSvgIcons = [
  <VisaCard />,
  <AmexCard />,
  <MasterCard />,
  <JCBCard />,
  <DiscoverCard />,
  <DinerClubCard />,
];

export const homeTabIcons = {
  home: <HomeIcon />,
  homeFilled: <HomeFilledIcon />,
  resources: <ResourcesIcon />,
  resourcesFilled: <ResourcesFilledIcon />,
  advising: <CoachingIcon />,
  advisingFilled: <CoachingFilledIcon />,
  shopping: <StoreIcon />,
  shoppingFilled: <StoreFilledIcon />,
};

export {
  BaselineErrorIcon,
  CheckCircleIcon,
  EmptyReadings,
  EmptyContacts,
  EmptyCards,
  EmptyAddresses,
  EmptyFeed,
  Logo,
  LogoGroup,
  CheckboxUncheckedIcon,
  CheckboxCheckedIcon,
  RadioUncheckedIcon,
  RadioCheckedIcon,
  FilterIcon,
  VerticalDotsIcon,
  UpArrowIcon,
  DownArrowIcon,
  LeftArrowIcon,
  RightArrowIcon,
  LockIcon,
  HeartIcon,
  HeartFilledIcon,
  CloseIcon,
  TickIcon,
  PlusIcon,
  MapPinIcon,
  MapPinFilledIcon,
  LinkIcon,
  USAFlag,
  ClosedEyeIcon,
  OpenEyeIcon,
  SmileIcon,
  RefreshIcon,
  CardFilledIcon,
  CardIcon,
  BluetoothIcon,
  EditIcon,
  NoNetworkIcon,
  UsersIcon,
  HotspotIcon,
  MoneyIcon,
  MapLocationIcon,
  BloodIcon,
  InfoRectIcon,
  LocationQuestionIcon,
  LogoutIcon,
  UserIcon,
  RequestFailedIcon,
  UserFilledIcon,
  SeparatorIcon,
  AddIcon,
  MessageIcon,
  EmailIcon,
  PhoneIcon,
  RecentReadingsIcon,
  TimeIcon,
  DateIcon,
  ClockIcon,
  LongBackArrowIcon,
  ShareIcon,
  CartIcon,
  CalendarIcon,
  PurchaseSuccessIcon,
  HypoArrowIcon,
  HyperArrowIcon,
  NormalLevelIcon,
  Triangle,
  MakeAppointmentIcon,
  NoAdvisors,
};
